import React from 'react';

import TemplateDashboard from "../../components/TemplateDashboard";
import SatisfaccionContent from './components/SatisfaccionContent';

const SatisfaccionListado = () => {

    return (
        <>

            <TemplateDashboard>
                <SatisfaccionContent />
            </TemplateDashboard>

        </>
    )
};

export default SatisfaccionListado;